<template>
  <div class="">
    <div class="myt-test">
      <div class="myt-new-test">
        <div class="myt-name-search">
          <div class="search-test-name">
            <v-text-field
              v-model="testName"
              @keydown="onSearchTest()"
              solo
              label="Search Test"
              dense
              outlined
              hide-details
              append-icon="search"
              autocomplete="off"
            ></v-text-field>
          </div>
        </div>
        <div class="text-center">
          <v-btn class="right-btn cust-btn" color="primary" @click="gotoCreateTest()">
            Create New Test
          </v-btn>
        </div>
      </div>
      <div class="mx-auto normal-card no-border-myt">
        <div class="data-table-section CustomizedTest">
          <v-data-table :headers="headers" fixed-header :items="items" hide-default-header hide-default-footer
            class="elevation-2 cust-table">
            <template v-slot:header="{ props: { headers } }">
              <TableHeader :headers="headers" :orderBy="orderBy" :onSortChange="onSortChange" />
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr style="position:relative" v-for="item in items" :key="item.id"  @click="onClickPreview($event,item)">
                  <td class="text-left myt-td-1">
                    <span>
                      {{ item.test_name }}
                    </span>
                  </td>

                  <td class=" text-left myt-td-2">
                    {{ getFormatedDate(item.created_at) }}
                  </td>
                  <td class="text-left myt-td-3">
                    {{ item.target_name }}
                  </td>
                  <td class="duration-display text-left myt-td-4">
                    {{ item.subjects }}
                  </td>
                  <td class=" text-left myt-td-5 download-icon">
                    <div class="download-view">
                      <img src="../../../assets/img/view-icon-myt.svg" class="view-icon view-icon-img"
                        @click="onClickPreview(item)" />
                      <span v-if="!user || item.is_purchased === 1" class="dowload-span"
                        >
                        <v-img class="loader-img myt-loader" src="../../../assets/img/loading.gif" v-if="item.status == downloadStatus.IN_PROGRESS"
                    ></v-img>
                    <!-- <v-btn
                      v-else-if="item.status===downloadStatus.COMPLETED"
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click.stop="downloadTestURL(item)"
                    >
                      <v-img
                        src="../../../assets/img/svg/download2.svg"
                      ></v-img>
                    </v-btn> -->
                    <v-btn
                      v-else
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click.stop="downloadTest(item)"
                    >
                      <v-img
                        width="23px"
                        src="../../../assets/img/download.svg"
                      ></v-img>
                    </v-btn></span>
                      <span v-else class="pay-dowload-span" @click.stop="showPaymentPopup(item)">
                        Pay to Download</span>
                      <!--span class="pay-dowload-span">Pay & Download</span-->
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </div>
      <div class="footer-btn">
        <div class="pull-left"></div>
        <div class="pull-right myt-pagiation">
          <Pagination :currentPage="currentPage" :totalPage="totalPages" :onPageChange="onPageChange" />
        </div>
      </div>
      <AlertBox :width="modalwidth" :onClose="onClose" :component="cComponent" :status="status" :data="alertBoxData" />
      <div v-if="innerWidth<991" class="mt-3">Swipe right for more details</div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import constants from "../../../utils/constants";
export default {
  name: "MyTests",
  data() {
    return {
      orderBy: {
        field: "created_at",
        order: "DESC"
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      headers: [
        {
          text: "Test Name",
          value: "test_name",
          class: "text-left myt-td-1 padding-left-15",
          hideSort: true
        },
        { text: "Created On", value: "created_at", class: "myt-td-2", hideSort: true },
        {
          text: "Target Exams",
          value: "subjects",
          class: "text-left myt-td-3",
          hideSort: true
        },
        {
          text: "Subjects",
          value: "subjects",
          class: "text-left myt-td-4",
          hideSort: true
        },
        {
          text: "Action",
          align: "center",
          value: "duration-display",
          class: "text-left myt-td-5",
          hideSort: true
        }
      ],
      items: [],
      modalwidth: "1000",
      cComponent: "",
      status: false,
      testName: "",
      alertBoxData: {},
      header_footer_details: {
        is_purchased: 0,
        header: {
          url: 'https://catv2-header-footer-stage.s3.ap-south-1.amazonaws.com/1681104939769_Screenshot%202023-04-04%20at%204.41.56%20PM.png',
          align: 'center',
          cover: true,
          contain: true
        },
        footer: {
          url: 'https://catv2-header-footer-stage.s3.ap-south-1.amazonaws.com/1681104939769_Screenshot%202023-04-04%20at%204.41.56%20PM.png',
          align: 'center',
          cover: true,
          contain: true
        }
      },
      onPopUpPayment: false,
      onPopUpTermsAndConditions: false,
      innerWidth:"",

      downloadStatus:{},
      requestIds:[],
      testStatusTimeout: 0,
      toasts:{}
    };
  },

  mounted() {
    this.checkSessionData();
    this.innerWidth=window.innerWidth;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    ...mapActions({
      getMYTTestList: "testStore/getMYTTestList",
      loginMyt: "userStore/loginMyt",
      verifyOtpMyt: "userStore/verifyOtpMyt",

      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
    }),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.requestIds = crd.tabDetails[crd.selectedTab].requestIds || []; // load center ids from session
        // this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      
      this.requestGetTestList();
      this.checkDownloadUpdate();
      this.downloadStatus = constants.DOWNLOAD_STATUS;
    },
   
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);        
      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, requestIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };        
        this.setRouteDetails(routeDetails);
      }
      this.defaultData()
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    downloadTest(item,isLogin=false) {
      if ((this.user || isLogin )&& item.is_purchased === 1) {
        this.cComponent = 'components/coordinator/Tests/DownloadTestPopup'
        this.alertBoxData = {
          ...item,
          tab: 'Offline',
          userType: 'MYT'
        };
        this.status = true;
        this.modalwidth = '550px'
      }else if(!this.user){
        this.cComponent = "components/CustomInstituteComponents/Login/MYTLogin";
        this.status = true;
        this.alertBoxData = {openDownloadPopup:true,item}
        this.modalwidth = '500px'
      }else if(item.is_purchased === 0){
        this.$toasted.error(`Please pay for downloading test`);
      }
    },

    onSearchTest() {
      this.resetFields();
      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.requestGetTestList();
      }, 1500);
    },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
    onClose(data) {
      if (data.showTermsAndConditions && !this.onPopUpTermsAndConditions) {
        this.showTermsAndConditions(data);
        this.onPopUpTermsAndConditions = true;
      } else if (data && this.onPopUpTermsAndConditions) {
        this.showPaymentPopup(data)
        this.onPopUpTermsAndConditions = false;
      }else if (data && data.login) {
        this.mytLogin(data.mobileNumber,data.password,data.openDownloadPopup,data.item)
      }else if (data && data.verify_otp) {
        this.verifyOtp(data)
      }else if (data && data.edit) {
        this.cComponent = "components/CustomInstituteComponents/Login/MYTLogin";
        this.alertBoxData = data;
      }else if (data && data.openDownloadPopup && data.test){
        if ( data.test.is_purchased ===1) {
          this.status = false
          this.downloadTest(data.test,true)
        }else{
          this.showPaymentPopup(data.test,true)
        }
      }else{
        this.status = data.status;
        if (data.isClearData) {
          this.alertBoxData={}
        }
        this.onPopUpTermsAndConditions=false
      }
      if (data && data.data) {
        let domainUrl = process.env.VUE_APP_API_URL;
        let token = sessionStorage.getItem("auth_token");
        let api = 'download-test';
        let query = `custom=offline&token=${token}&column=${data.isTwoColumn}&isRoughWork=${data.isRoughWork}&pageBreak=${data.pageBreak}`;
        if (data.download_option === 2) {
          api = 'download-answer-key';
          query = `token=${token}`
        } else if (data.download_option === 3) {
          api = 'download-test-solution'
          query = `token=${token}`
        }
        let url =
          domainUrl + `/myt-test/${api}/${data.data.id}?${query}`;
          if (data.download_option === 2) {
          window.open(url, "_blank");
        } else {
          this.downloadTestResource(
            `myt-test/${api}/${data.data.id}?${query}`,
            data.data
          );
        }
        //   alert(url);
      }
    },

    downloadTestResource(url, test) 
    {
      this.items = this.items.map((item)=>{
          if (item.id === test.id) {
            item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS
          }
          return item
        })
      this.toasts[test.id] =  this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info',duration: null,id: test.id.toString()})
      this.downloadTestPaper(url)
        .then((res) => {
          // console.log(res);
          this.requestIds.push(res.request_id);
          // this.$toasted.dismiss()

          this.updateRouteDetails({
            type: "requestIds",
            data: { requestIds: this.requestIds },
          });
          this.items = this.items.map((item) => {
            if (item.id === test.id) {
              item.request_id = res.request_id;
            }
            return item
          });
          this.checkDownloadUpdate();

          // this.requestGetTestList()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkDownloadUpdate() {
      console.log(this.requestIds, "request_ids");

      if (this.testStatusTimeout) {
        clearInterval(this.testStatusTimeout);
        this.testStatusTimeout = null;
      }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [
          constants.DOWNLOAD_TYPES.TEST_PAPER,
          constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
          constants.DOWNLOAD_TYPES.OMR,
        ],
      };
      this.getDownloadStatus(reqData)
        .then(async(res) => {
          const arr = [];
          this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if(item.url){
                arr.push({
                  url: data.url,
                  request_id: data.request_id
                })
              }
              // this.downloadTestURL(item)
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );
              this.toasts[item.id].goAway(0)
              delete this.toasts[item?.test_id];
              delete this.toasts[item.id]

              this.$toasted.success(`Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,{icon: 'info'})
            }
          });
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item);
            
           await new Promise(resolve => {
            console.log('Starting delay');
            setTimeout(() => {
              resolve();
              }, 1000);
            });
          }
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {
       });
    },
    downloadTestURL(item) {
      console.log(item);

      if (item.url && item.request_id) {
         window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };
        this.deleteDownloadData(reqData)
          .then((res) => {
            this.items =this.items.map((data)=>{
                if (data.request_id==item.request_id) {
                    
                    data.status = null;
                    data.request_id = null;
                    data.url = null;
                }
                return data
            })
            this.$forceUpdate()
          })
          .catch((err) => {});
      }
    },
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      console.log(routeName,"updateRouteDetails");
      
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "requestIds":
          crd.tabDetails[crd.selectedTab].requestIds = details.data.requestIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    mytLogin(mobileNumber, password,openDownloadPopup=false,test=null){
      let reqData = {
        phone: this.getMobileNumberWithCountryCode(mobileNumber.countryCode,mobileNumber.number),
        password: password
      }
      this.loginMyt(reqData)
      .then(res=>{
        if (password) {
          this.status = false;
        }else{
          this.cComponent =  "components/CustomInstituteComponents/Login/LoginOTP"
          this.alertBoxData = res.user;
          this.alertBoxData.resendOtp = res.resend_otp_time;
          this.alertBoxData.openDownloadPopup = openDownloadPopup;
          this.alertBoxData.test=test
        }
      })
      .catch(err=>{
        console.log(err);
      })
    },
    verifyOtp(data){
      let reqData = {
        phone:data.phone,
        otp:data.otp.slice(0,6),
        user_id: localStorage.getItem('guest_user_id'),
        register_id: data ? data.id : null
      }
      this.verifyOtpMyt(reqData)
      .then(res=>{
        if (res.isNewUser) {
          this.cComponent =  "components/CustomInstituteComponents/Login/MYTRegister";
          this.alertBoxData = {...res.user,openDownloadPopup:data.openDownloadPopup,test:data.test};
        }else{
          this.status= false
          this.alertBoxData={}
          this.requestGetTestList(data.test);
        }
      })
      .catch(err=>{
        console.log(err);
      })
    },
    showPaymentPopup(data,isLogin=false) {
      if (this.user || isLogin) {
        this.alertBoxData = data
        this.alertBoxData.persistent = true;
        this.cComponent ="components/CustomInstituteComponents/Payment/PaymentPopup";
        this.status = true;
        this.modalwidth = '576px';
      }else{
        this.$toasted.error(`Please login to make payment`);
      }
    },
    showTermsAndConditions(data) {
      this.alertBoxData = data;
      this.alertBoxData.showTermsAndConditions = data.showTermsAndConditions
      this.alertBoxData.prodObj = data.prodObj;
      this.modalwidth = "576px";
      this.status = true;
      this.cComponent = "components/CustomInstituteComponents/Payment/TermsAndCondition";
    },
    gotoCreateTest() {
      this.$router.push({ name: "customized-tests-myt" });
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onClickPreview(e,test) {
        let params = {
          test_id: test.id,
          test_institute_id: test.test_institute_id,
        };
        this.$router.push({ name: "preview-myt-test", params: params, });
    },
    requestGetTestList(item) {
      let reqData = {
        myt_creator_id: this.user ? this.user.id.toString() : localStorage.getItem('guest_user_id'),
        test_name: this.testName,
        test_types: [
          5
        ],
        test_sub_types: [
          21
        ],
        orderBy: this.orderBy,
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize
        }
      };
      this.getMYTTestList(reqData)
        .then((response) => {
          this.items = response.list;
          this.totalPages = response.pagination.pageCount;
          if (item) {
            let testDetails = this.items.find((c) => c.id === item.id);
            if(testDetails && testDetails.is_purchased === 1){
              this.downloadTest(testDetails,true)
            }else if (testDetails && testDetails.is_purchased === 0){
              this.showPaymentPopup(testDetails);
            }else{
              this.$toasted.error(`You are exceeded your 10 test limit so you lost your test`);
            }
          }
        })
        .catch((err) => {

        });
    },
    checkStudentUpgraded() {
      this.status = true;
      this.cComponent =
        "components/CustomInstituteComponents/Payment/PaymentPopup";
      this.modalwidth = "530px";
      this.alertBoxData = {};
      return this.status;//true
      // return false;
    },

  },
  computed: {
    ...mapState("userStore", ["user", "pendingTestList"]),

  },
  watch: {
    user(val) {
      if (val && val.id) {
        this.requestGetTestList()
      }
    },
    cComponent(val){
    }
  }
};
</script>
